import { AutosaveBoundary } from '@/core/components/form/AutosaveBoundary'
import { currentAutosaveScope } from '@/core/api/autosaveScope'
import { SubShell } from 'admination-react'
import type { ReactNode } from 'react'
import { useApp, useCoachingRow } from '@/core/state/appStore'
import { PhaseContent } from './PhaseContent'

export function ModalOverlay({ children, recordActions }: { children?: ReactNode; recordActions?: ReactNode }) {
  const { state, dispatch } = useApp()
  const record = useCoachingRow(state.screen?.coachingId ?? null)

  const anchorKey =
    state.screen?.kind === 'member' ? (state.screen.memberId ?? 'none')
    : state.screen?.kind === 'massnahme' ? (state.screen.massnahmeId ?? 'none')
    : state.screen?.kind === 'modul' ? JSON.stringify([state.screen.massnahmeId, state.screen.modulId])
    : (state.screen?.coachingId ?? state.screen?.kind ?? 'none')

  if (!state.screen || state.screen.tab === null) return null

  const size = state.screen?.kind === 'dokument' ? 'document' : 'form'

  return (
    <SubShell key={state.screen?.source?.kind === 'row' ? 'list-detail' : anchorKey} source={state.screen?.source ?? undefined} size={size} onClose={() => dispatch({ type: 'DISMISS' })}>
      <AutosaveBoundary key={anchorKey} label={['member', 'massnahme', 'modul'].includes(state.screen?.kind) ? undefined : record?.name ?? undefined} identity={JSON.stringify([currentAutosaveScope(), ['member', 'massnahme', 'modul'].includes(state.screen?.kind) ? state.screen?.kind : 'coaching', anchorKey])}><PhaseContent actions={recordActions} /></AutosaveBoundary>
      {children}
    </SubShell>
  )
}
